var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23C5.14884,23,0,17.8512,0,11.5C0,5.14884,5.14884,0,11.5,0C17.8512,0,23,5.14884,23,11.5C23,17.8512,17.8512,23,11.5,23ZM11.5,21.275C16.8987,21.275,21.275,16.8987,21.275,11.5C21.275,6.10132,16.8987,1.725,11.5,1.725C6.10133,1.725,1.725,6.10132,1.725,11.5C1.725,16.8987,6.10133,21.275,11.5,21.275ZM12.3625,10.6375L15.8125,10.6375C16.2885,10.638,16.6742,11.024,16.6742,11.5C16.6742,11.976,16.2885,12.362,15.8125,12.3625L12.3625,12.3625L12.3625,15.8125C12.3625,16.2888,11.9763,16.675,11.5,16.675C11.0237,16.675,10.6375,16.2888,10.6375,15.8125L10.6375,12.3625L7.1875,12.3625C6.71115,12.3625,6.325,11.9763,6.325,11.5C6.325,11.0237,6.71115,10.6375,7.1875,10.6375L10.6375,10.6375L10.6375,7.1875C10.6375,6.71115,11.0237,6.325,11.5,6.325C11.9763,6.325,12.3625,6.71115,12.3625,7.1875L12.3625,10.6375Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dd7c3d695b3ed1f3b45ce2ef7bc50b23.svg";
export { ForwardRef as ReactComponent };